<template>
  <!-- ldna-modal: the phone rules in modal.scss apply to this component only -->
  <div v-if="isVisible" class="modal-overlay ldna-modal" @click="close">
    <div
      :class="[
       isSingleMethod
      ? 'modal-collection-content'
      : isConsultation
      ? 'modal-collection'
      : 'modal-content',
        title === 'Order' || title === 'Payment' ? 'order-modal' : '',
        title === 'Checkout'
          ? 'checkout-modal'
          : !title
          ? 'alert-modal'
          : title === 'Change Profile'
          ? 'switch-profile-modal'
          : '',
        contentClass,
      ]"
      @click.stop
    >
      <div v-if="title" class="header-modal">
        <p>{{ title }}</p>
        <button v-if="showCloseButton" class="close-button" @click="close">
          <img src="@/assets/cross-icon.png" alt="" />
        </button>
      </div>
      <div class="modal-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import "@/styles/components/modal.scss";
export default {
  name: "ModalView",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    showCloseButton: {
      type: Boolean,
      default: true,  // Default to true for most modals
    },
    isSingleMethod: {
      type: Boolean,
      default: false,  // Default to false if there's more than one method
    },
    isConsultation: {
      type: Boolean,
      default: false,  // Default to false if there's more than one method
    },
    contentClass: {
      type: String,
      default: '',
    },
  },
  created() {
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
